const checkFileExtension = (types: string, extensions: string[]) =>
  extensions.some((extension) => types.includes(extension));

export default checkFileExtension;
